module.exports = __webpack_public_path__ + "img/8_40.f4184126.png";